export function isMobileMode(){
    if (!window['matchMedia']) return false
        
    return matchMedia("(max-width: 767px)").matches
}